module.exports = __webpack_public_path__ + "static/media/notfound.c3576f1a.svg";